import React from "react";
import { useNavigate } from "react-router-dom";
import { Tooltip, Grid } from "@mui/material";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import ToolbarButton from "./button";

const addIconStyle = {
  fontSize: 24,
  margin: "7px 0px 0px 7px",
  color: "#B6B6B6",
};

const NewInterestButton: React.FC<{currentListId: string}> = ({ currentListId }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    const listId = currentListId;
    navigate(`/dash/manager/interests/${listId}/new`);
  };

  if (currentListId === "all") {
    return null;
  }
  return (
    <Tooltip title="Add Application">
      <Grid>
        <ToolbarButton
          className="NewInterestButton btn-table"
          onClick={handleClick}
          style={{
            boxShadow: "0 1px 2px 0 rgba(34,36,38,.07)",
          }}
        >
          <AddCircleIcon
            style={addIconStyle}
          />
        </ToolbarButton>
      </Grid>
    </Tooltip>
  );
};

export default NewInterestButton;
